// src/components/ProtectedRoute.js
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { validateToken } from "../store/authSlice";
import { CircularProgress, Box, Typography } from "@mui/material";

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isAuthenticated, loading, initialized } = useSelector(
    (state) => state.auth
  );

  // Validate token on load
  useEffect(() => {
    dispatch(validateToken());
  }, [dispatch]);

  // Redirect unauthenticated users to login
  useEffect(() => {
    if (initialized && !loading && !isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [initialized, loading, isAuthenticated, navigate]);

  if (loading || !initialized) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #0D1117, #1B263B)",
          color: "#fff",
        }}
      >
        <CircularProgress sx={{ color: "#4FC3F7", mb: 2 }} />
        <Typography variant="h6">Validating Session...</Typography>
      </Box>
    );
  }

  return isAuthenticated ? children : null;
};

export default ProtectedRoute;
